<template>
  <section class="listing">
    <div class="header">
      <div class="title">Tipos de Ingresso</div>
      <button @click="$router.push('/ticket-type/new')" class="button-new button-add"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <form @submit.prevent class="form" style="padding: 0 0 15px">
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="t in filtered" :key="t.id" class="list">
          <div class="data">
            <div class="main-data" style="text-transform: capitalize">{{ t.name }}
              <span v-if="t.ticketDesc" style="margin:0 0 0 10px;font-size:18px;"><i class="fas fa-info-circle"></i></span>
            </div>
          </div>
          <div class="actions">
            <button v-show="!t.name.includes('Mesa ')" @click="$router.push(`/ticket-type/${t.id}`)" class="button-action"><i class="fas fa-pen"></i><span>Alterar</span></button>
          </div>
        </div>
      </div>
    </transition>
    <TicketType v-if="type" :id="type" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/ticketType'
import TicketType from './TicketType.vue'

export default {
  name: 'ticketTypes',

  components: { TicketType },
  props: ['id'],
  data () {
    return {
      loading: true,
      type: null,
      types: [],
      search: ''
    }
  },
  computed: {
    filtered () {
      return this.types.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.type = value.params['id'] ? value.params['id'] : null
      // Update list
      if (!value.params['id']) {
        try {
          this.loading = true
          this.types = await getAll()
          this.loading = false
        } catch (error) {
          logger.error(error, this)
        }
      }
    }
  },
  async mounted () {
    try {
      this.type = this.id ? this.id : null
      this.types = await getAll()
      this.loading = false
    } catch (error) {
      logger.error(error, this)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-add {
  position: relative !important;
  bottom: auto !important;
  right: auto !important;
  z-index: 0 !important;
  // margin: 0 10px;
}

.main-data {
  font-size: 1em !important;
}

.search-input {
  min-width: 200px;
  position: relative;
  input {
    width: 100%;
  }
  i {
    position: absolute;
    top: 11px;
    right: 6px;
    color: #666;
    font-size: 1.5em;
  }
}
</style>
